import HTMLParse from 'react-html-parser'
import Helmet from 'react-helmet'

const Meta = ({ meta = '' }) => <Helmet>{HTMLParse(meta)}</Helmet>

export default Meta
